// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"40cad772","158":"5d603365"}[chunkId] + ".chunk.css";
};